import React, { useState } from "react"
import { storage, db } from "../../firebase";
import { ref as dbRef, set } from "firebase/database";
import { ref as strRef, uploadBytes } from "firebase/storage";
import { v4 } from 'uuid';
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';

function UploadPost() {
    const [img, setImg] = useState("");
    const [caption, setCaption] = useState("");
    const [errors, setErrors] = useState([]);

    function validateForm() {
        setErrors(errors.splice(0, errors.length));
        if (caption === '' || img === '') {
            setErrors([...errors, 'Caption and image selection is required']);
            return false;
        }
        return true;
    }

    const handleClick = () => {
        const isValid = validateForm();
        if (isValid) {
            let fileName = v4();
            const imgRef = strRef(storage, 'projects/' + fileName);
            uploadBytes(imgRef, img);
            set(dbRef(db, 'images/' + fileName), {
                src: 'https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F' + fileName + '?alt=media',
                caption: caption
            });
            setCaption("");
        }
    }

    return (
        <Container fluid style={{ marginBottom: '50px', marginTop: '100px' }} className="d-flex justify-content-center align-items-center">

            <div style={{ width: '80%', maxWidth: '500px' }}> 

                <div className="mb-3 text-center">
                    <h3>Upload new post from here</h3>
                </div>

                <div style={{ color: 'red' }}>
                    {errors.map((message, index) => (
                        <div>
                            <span key={index}>{message}</span> <br />
                        </div>
                    ))}
                </div>

                <div className="mb-3">
                    <Form.Control
                        accept="image/png, image/jpg, image/jpeg"
                        type="file"
                        onChange={(e) => setImg(e.target.files[0])}
                        placeholder="Select file to upload"
                    />
                </div>

                <div className="mb-3">
                    <Form.Select
                        value={caption}
                        onChange={(e) => setCaption(e.target.value)}>
                        <option value=""></option>
                        <option value="Bedroom">Bedroom</option>
                        <option value="Living Room">Living Room</option>
                        <option value="Kitchen">Kitchen</option>
                        <option value="Site Execution">Site Execution</option>
                        <option value="Commercial">Commercial</option>
                        <option value="2D Design">2D Design</option>
                    </Form.Select>
                </div>

                <div className="d-flex justify-content-center">
                    <Button
                        variant="primary"
                        id="submit"
                        onClick={() => handleClick()}
                    >
                        Submit
                    </Button>
                </div>
            </div>
        </Container>
    );
}

export default UploadPost;